import api from 'api';
import ApiService from 'api/ApiService';
import {unpackId} from 'common/diplomatIdUtil';
import {DialogTypes} from 'common/names';
import {NameFormType} from 'components/dialogs/NameDialog';
import {layoutSelectors} from 'features/layout/redux';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {pushSuccessToast} from 'features/notifications/redux/actions';
import i18n from 'i18n';
import {call, put, select} from 'redux-saga/effects';
import {asyncSagaConstructor} from 'redux/common';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';
import {Action} from 'redux/helpers';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {keyTypes} from '..';

export function* replaceKey({payload}: Action<IDiplomatObject>) {
   const keys = (yield select(layoutSelectors.keysSelector)) as ReturnType<
      typeof layoutSelectors.keysSelector
   >;
   const {id: existingKeyId} = unpackId(payload?.id);

   let url: string;
   let options: IDiplomatObject[];
   switch (payload?.objectType) {
      case DiplomatObjectType.enum.KEY_PAIR:
         options = keys.openpgp.secretKeys;
         url = api.pgpKeyReplace;
         break;

      case DiplomatObjectType.enum.PUBLIC_KEY:
         options = keys.openpgp.publicKeys;
         url = api.pgpKeyReplace;
         break;

      case DiplomatObjectType.enum.SSH_KEY:
         options = keys.ssh.clientKeys.filter(
            (k) => k.objectType === DiplomatObjectType.enum.SSH_KEY
         );
         url = api.sshKeyReplace;
         break;
      case DiplomatObjectType.enum.SSH_PUBLIC_KEY:
         options = keys.ssh.clientKeys.filter(
            (k) => k.objectType === DiplomatObjectType.enum.SSH_PUBLIC_KEY
         );
         url = api.sshKeyReplace;
         break;

      default:
         options = [];
         url = '';
   }
   options = options.filter((o) => o.id !== existingKeyId);
   // TODO remove current id from options;

   try {
      const res: ICloseSubDialogAction<NameFormType> = yield call(openDialogWithResult, {
         id: DialogTypes.ReplaceKey.id,
         data: {
            //    keys,
            //    secret,
            title: i18n.t('Replace Key'),
            label: i18n.t('Choose replacement key'),
            options,
         },
      });
      const newKeyId = res.payload?.data?.name;
      console.debug('Replace with', newKeyId);
      if (newKeyId) {
         yield call(
            asyncSagaConstructor(url, keyTypes.REPLACE_KEY, {
               getMethod: ApiService.postSecureJson,
               data: {
                  existingKeyId,
                  newKeyId,
               },
            })
         );

         yield put(pushSuccessToast(i18n.t('Key has been replaced')));
      }
   } catch (e) {
      console.error('Unhandler error', e);
   }
}
